/** @format */

export function FindColor(path: string, theme: any) {
  return path.split('.').reduce((p, c) => (p && p[c]) || null, theme);
}
